(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@normy/core"), require("react"), require("swr"));
	else if(typeof define === 'function' && define.amd)
		define(["@normy/core", "react", "swr"], factory);
	else if(typeof exports === 'object')
		exports["NormySwr"] = factory(require("@normy/core"), require("react"), require("swr"));
	else
		root["NormySwr"] = factory(root["Normy"], root["React"], root["Swr"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__700__, __WEBPACK_EXTERNAL_MODULE__359__, __WEBPACK_EXTERNAL_MODULE__115__) => {
return 